function calculateProfileScore(userResponses, questionIds) {
    return userResponses
        .filter(userResponse => !questionIds || questionIds.includes(userResponse.questionId))
        .reduce((sum, userResponse) => sum + (userResponse.score || 0), 0);
}

function getArchetype(score, archetypes) {
    return archetypes.find(archetype => score <= archetype.maxScore) || archetypes[archetypes.length - 1];
}

export {
    calculateProfileScore,
    getArchetype
};
